import { ChangeDetectionStrategy, Component } from '@angular/core'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { BROWSER_VERSION_SUPPORTED } from 'projects/aiomed/src/core/helpers/is-browser-supported'

@Component({
  selector: 'aiomed-unsupported-browsers',
  imports: [NzIconModule],
  templateUrl: './unsupported-browsers.component.html',
  styleUrl: './unsupported-browsers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsupportedBrowsersComponent {
  protected readonly browserVersionSupported = BROWSER_VERSION_SUPPORTED
}
